import React, { useState } from "react";
import ProductFilters from "../components/ProductFilters";
import ProductTable from "../components/ProductTable";
import ProductModal from "../components/ProductModal";
import { toast, Toaster } from "react-hot-toast";

const Products = () => {
  const initialProducts = [
    { name: "Manzanas Orgánicas", category: "Frutas", price: "$2.50", stock: 150 },
    { name: "Carne de Res Alimentada con Pasto", category: "Carne", price: "$12.99", stock: 80 },
    { name: "Pan Integral", category: "Panadería", price: "$3.75", stock: 120 },
    { name: "Huevos de Gallinas Libres", category: "Lácteos", price: "$4.25", stock: 200 },
    { name: "Leche de Almendras", category: "Lácteos", price: "$3.50", stock: 100 },
  ];

  const [products, setProducts] = useState(initialProducts);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingIndex, setEditingIndex] = useState(null);
  const [modalData, setModalData] = useState({ name: "", category: "", price: "", stock: "" });

  const openModal = (product = null, index = null) => {
    if (product) {
      setModalData(product);
      setEditingIndex(index);
    } else {
      setModalData({ name: "", category: "", price: "", stock: "" });
      setEditingIndex(null);
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const saveProduct = (data) => {
    if (editingIndex !== null) {
      const updated = [...products];
      updated[editingIndex] = data;
      setProducts(updated);
      toast.success("Producto actualizado");
    } else {
      setProducts([...products, data]);
      toast.success("Producto agregado");
    }
    closeModal();
  };

  const deleteProduct = (index) => {
    const updated = products.filter((_, i) => i !== index);
    setProducts(updated);
    toast.success("Producto eliminado");
  };

  return (
    <div className="mx-auto max-w-7xl p-4">
      <Toaster position="top-right" />
      <div className="mb-6 flex flex-col items-start justify-between gap-4 sm:flex-row sm:items-center">
        <h1 className="text-3xl font-bold text-white">Productos</h1>
        <button
          onClick={() => openModal()}
          className="flex items-center gap-2 rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-600"
        >
          <span className="material-symbols-outlined">add</span>
          Agregar Producto
        </button>
      </div>

      <ProductFilters />

      <div className="overflow-x-auto rounded-md border border-gray-800 bg-gray-900 mt-4">
        <ProductTable
          products={products}
          onEdit={openModal}
          onDelete={deleteProduct}
        />
      </div>

      {isModalOpen && (
        <ProductModal
          isOpen={isModalOpen}
          onClose={closeModal}
          onSave={saveProduct}
          data={modalData}
        />
      )}
    </div>
  );
};

export default Products;
